import { useCheckout } from '..';

const useTransactionDetails = () => {
  const data = [];
  const {
    checkoutSession: { sessionData },
    appliedDiscount
  } = useCheckout();

  const checkoutPriceBreakdown = sessionData?.pricing;

  if (checkoutPriceBreakdown?.discount && appliedDiscount.data) {
    data.push({
      subtitle: appliedDiscount.data.code,
      title: 'discountCode',
      value: -checkoutPriceBreakdown.discount
    });
  }

  if (checkoutPriceBreakdown?.feesBreakdown.processingFees) {
    data.push({
      subtitle: 'paymentProcessingFees',
      title: 'processingFees',
      value: checkoutPriceBreakdown?.feesBreakdown.processingFees
    });
  }

  if (checkoutPriceBreakdown?.feesBreakdown.bounceFees) {
    data.push({
      subtitle: 'perSelectedItemServiceFee',
      title: 'bounceFees',
      value: checkoutPriceBreakdown?.feesBreakdown.bounceFees
    });
  }

  if (checkoutPriceBreakdown?.taxes) {
    data.push({
      title: 'taxes',
      value: checkoutPriceBreakdown.taxes
    });
  }

  return data;
};

export default useTransactionDetails;
